module.exports = __webpack_public_path__ + "static/ik-4-3ecc8d3b88781b5b776b57d07983f253.png";